import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Hub } from '../types/hub';

@Component({
  selector: 'one-hub',
  template: `<div *ngIf="header" class="header">
    <ng-container *ngIf="prevHubs; else firstPage"><span class="hubid center" (click)="prevPage(true)">&lt;&lt;Prev</span></ng-container>
    <ng-template #firstPage><span class="hubid center" (click)="sortBy('hubid',true)">ID</span></ng-template>
    <span class="serial" (click)="sortBy('serial',false)">Serial</span>
    <span class="name" (click)="sortBy('name',false)">Name</span>
    <span class="version" (click)="sortBy('swversion',false)">Version</span>
    <span class="uptime" (click)="sortBy('uptime',true)">Up for</span>
    <span class="installed" (click)="sortBy('installed',false)">Installed</span>
    <span class="millivolts center" (click)="sortBy('voltage',true)">mV</span>
    <span class="last_seen" (click)="sortBy('age',true)">Last Seen</span>
    <span class="wake_secs" (click)="sortBy('avg_wake_secs',true)">Wake</span>
    <span class="gap" (click)="sortBy('gap',true)">Gap</span>
    <span class="rssi" (click)="sortBy('rssi',true)">Wifi</span>
    <span class="setpoint" (click)="sortBy('setpoint',true)">Set</span>
    <span class="temperature" (click)="sortBy('temperature',true)">Temp</span>
</div>
<div *ngIf="footer" class="footer">
    <span class="hubid center" (click)="nextPage(true)">Next&gt;&gt;</span>
    <span class="serial">Serial</span>
    <span class="name">Name</span>
    <span class="version">Version</span>
    <span class="uptime">Up for</span>
    <span class="installed">Installed</span>
    <span class="millivolts center">mV</span>
    <span class="last_seen">Last Seen</span>
    <span class="wake_secs">Wake</span>
    <span class="gap">Gap</span>
    <span class="rssi">Wifi</span>
    <span class="setpoint">Set</span>
    <span class="temperature">Temp</span>
</div>
<div *ngIf="!header && !footer && inHub" class="row">
    <span class="hubid"> {{inHub.hubid}} </span>
    <span class="serial"> {{inHub.serial}} </span>
    <span class="name"> {{inHub.name}} </span>
    <span class="version"
          [style.border-color]="this.versionColor()"> {{inHub.swversion | version}} </span>
    <span class="uptime"
          [style.border-color]="this.uptimeColor()"> {{inHub.uptime | humaninterval}} </span>
    <span class="installed"> {{inHub.installed | godate}} </span>
    <span class="millivolts"
          [style.border-color]="this.voltageColor()"> {{inHub.voltage}} </span>
    <span class="last_seen"
          [style.border-color]="this.ageColor()"> {{inHub.age | humaninterval}} </span>
    <span class="wake_secs"
          [style.border-color]="this.wakeColor()"> {{inHub.avg_wake_secs}} </span>
    <span class="gap"
          [style.border-color]="this.gapColor()"> {{inHub.gap}} </span>
    <span class="rssi"> {{inHub.rssi}} </span>
    <span class="setpoint"> {{inHub.setpoint | degrees}} </span>
    <span class="temperature"> {{inHub.temperature | degrees}} </span>
</div>
`,
  styles: [`span { display: inline-block; margin: 0.1em 0.2em; padding: 0.1em 0.3em; border: 2px solid transparent;
              border-radius: 6px; line-height: 200%; }`,
    `span.hubid { color: white; padding-left: 0.6em; padding-right: 0.6em; background-color: #607D8B; width: 2.5em;
              border-radius: 0; border: none; }`,
    `.serial { width: 4em; }`,
    `.name { width: 14em; }`,
    `.version { width: 3.5em; }`,
    `.uptime { width: 5em; text-align: right; }`,
    `.installed { width: 7em; text-align: center; }`,
    `.millivolts { width: 3.5em; text-align: right; }`,
    `.last_seen { width: 5em; text-align: right; }`,
    `.wake_secs { width: 4em; text-align: right;}`,
    `.gap { width: 4em; text-align: right;}`,
    `.rssi, .setpoint, .temperature { width: 3.5em; text-align: right; }`],
})


export class OneHubRowComponent {
  @Input() inHub: Hub;
  @Input() header = false;
  @Input() footer = false;
  @Input() prevHubs = false;
  @Output() sortColumn = new EventEmitter<string>();
  @Output() gotoPrev = new EventEmitter<boolean>();
  @Output() gotoNext = new EventEmitter<boolean>();
  hubCount = 0;
  currentHub: Hub;
  errorMessage: any;

  constructor(
  ) { }

  sortBy(column: string, numeric: boolean) {
    this.sortColumn.emit(column + ':' + numeric);
  }

  nextPage() {
    this.gotoNext.emit(true);
  }

  prevPage() {
    this.gotoPrev.emit(true);
  }

  voltageColor(): string {
    if (this.inHub.voltage < 3700) { return '#F04040'; }
    if (this.inHub.voltage < 3800) { return '#F06060'; }
    if (this.inHub.voltage < 3900) { return '#F08080'; }
    return 'transparent';
  }

  uptimeColor(): string {
    if (this.inHub.uptime < 400) { return '#F40000'; }
    if (this.inHub.uptime < 1600) { return '#F41818'; }
    if (this.inHub.uptime < 4800) { return '#F43030'; }
    if (this.inHub.uptime < 19200) { return '#F44848'; }
    if (this.inHub.uptime < 38400) { return '#F46060'; }
    if (this.inHub.uptime < 86400) { return '#F47878'; }
    if (this.inHub.uptime < 432000) { return '#F49090'; }
    return 'transparent';
  }

  ageColor(): string {
    if (this.inHub.age > 86400) { return '#F40000'; }
    if (this.inHub.age > 43200) { return '#F32020'; }
    if (this.inHub.age > 15000) { return '#F24040'; }
    if (this.inHub.age > 7500) { return '#F16060'; }
    if (this.inHub.age > 3700) { return '#F08080'; }
    if (this.inHub.age > 1500) { return '#EF9090'; }
    if (this.inHub.age > 400) { return '#EEa0a0'; }
    return 'transparent';
  }

  versionColor(): string {
    if (this.inHub.major > 0) {
      return 'transparent';
    }
    if (this.inHub.minor === 7 && this.inHub.patch === 2) {
      return 'transparent';
    }
    if (this.inHub.minor < 9) { return '#f00000'; }
    if (this.inHub.patch < 16) { return '#f06060'; }
    if (this.inHub.patch < 18) { return '#f0a0a0'; }
    return 'transparent';
  }

  wakeColor(): string {
    if (this.inHub.wake_secs > 60) { return '#F04040'; }
    if (this.inHub.wake_secs > 40) { return '#F06060'; }
    if (this.inHub.wake_secs > 20) { return '#F08080'; }
    return 'transparent';
  }

  gapColor(): string {
    if (this.inHub.gap > 7300) { return '#F04040'; }
    if (this.inHub.gap > 1900) { return '#F06060'; }
    if (this.inHub.gap > 400) { return '#F08080'; }
    return 'transparent';
  }

}

